import { render, staticRenderFns } from "./StoreMenu.vue?vue&type=template&id=f5720de4&"
import script from "./StoreMenu.vue?vue&type=script&lang=js&"
export * from "./StoreMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports